export default "__VITE_ASSET__BYREpsEZ__"